import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import CaptionFont from '../../../Theme/Fonts/Caption'
import VerticalSpacer from '../../../Layouts/Spacer/Vertical'
import SmallTeaserHeadlineFont from '../../../Theme/Fonts/SmallTeaserHeadline'
import Image from '../../../BaseComponents/Image'
import { TintColor } from '../../../BaseComponents/Image/ImageInterfaces'
import { RequireAtLeastOne } from '../../../utils/types/requireAtLeastOne'
import { TaboolaRegionItem } from '../../TeaserInterface'
import LinkProps from '../../../Link/LinkProps'

type Props = {
    /** published text */
    publishedAt: string
    /** url of channel image */
    channelIcon?: string
    /** info for seo about channelIcon */
    channelIconAlt?: string
    /** headline text */
    headline: string
    /** left and right space
     *
     * @defaultValue 16px
     */
    spaceX?: number | string | string[] | number[]
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback function triggered when component is pressed
     *
     * @TJS-type function
     * */
    onPress?: () => void
    /**
     * callback function triggered when component is long pressed
     *
     * @TJS-type function
     * */
    onLongPress?: () => void
    /** colors the corresponding image in black or white */
    tintColor?: TintColor
} & LinkProps &
    TaboolaRegionItem

export type NewsTickerLineProps = RequireAtLeastOne<Props, 'onPress' | 'href'>

const NewsTickerLine: FunctionComponent<NewsTickerLineProps> = ({
    publishedAt,
    channelIcon,
    channelIconAlt,
    headline,
    href,
    spaceX = 5,
    onPress,
    tintColor,
    onLongPress,
    webTBRegionItem,
    webRel,
}): ReactElement => {
    return (
        <Touchable
            onPress={onPress}
            href={href}
            onLongPress={onLongPress}
            webTBRegionItem={webTBRegionItem}
            webRel={webRel}
        >
            <VerticalSpacer space="small" backgroundColor="pearl" />
            <Grid horizontal paddingX={spaceX} centerVertical noExpand backgroundColor="pearl">
                <CaptionFont color="keshi-3">{publishedAt}</CaptionFont>
                <Grid noExpand marginX={5} padding={1} borderRadius={1} backgroundColor="pearl-4">
                    <Image
                        imageUrl={channelIcon}
                        alt={channelIconAlt}
                        aspectRatio="1:1"
                        width={14}
                        size="S"
                        tintColor={tintColor}
                    />
                </Grid>
                <Grid minWidth={0}>
                    <SmallTeaserHeadlineFont
                        className={webTBRegionItem === '' ? 's1-taboola-title' : undefined}
                        numberOfLines={1}
                        color="onyx-5"
                    >
                        {headline}
                    </SmallTeaserHeadlineFont>
                </Grid>
            </Grid>
            <VerticalSpacer space="small" backgroundColor="pearl" />
        </Touchable>
    )
}

export default NewsTickerLine
